import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { quoteBindAxios } from 'lib/quoteBind';
import { QB_RISK_DETAILS, QB_RISK_QUOTES } from 'lib/quoteBind/queryKeys';
import { enqueueNotification, hideModal } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
const reActivateQuote = async (params) => {
  try {
    const { id } = params;

    if (!id) {
      throw new Error('useReActivateQuote: id is required');
    }

    const result = await quoteBindAxios.put(`/quotes/${id}/reactivate`);
    return result?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useReActivateQuote = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.risks.useReActivateQuote',
    };

    dispatch(enqueueNotification('notification.generic.request', 'error'));
    dispatch(hideModal());

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (res) => {
    queryClient.invalidateQueries(QB_RISK_DETAILS, { id: res.riskId });
    queryClient.invalidateQueries([QB_RISK_QUOTES, { id: res.riskId }]);

    dispatch(hideModal());
    dispatch(enqueueNotification('notification.acceptRiskQuote.success', 'success'));
  };

  return useMutation({
    mutationFn: reActivateQuote,
    onSuccess: (res) => handleSuccess(res),
    onError: (err) => handleError(err),
    keepPreviousData: true,
  });
};
